<div class="pt-5 justify-content-center align-items-center">
  <hr>
  <!-- Header -->
  <div class="text-center mb-4">
    <h1 class="text-dark">Summarizer</h1>
    <div class="text-muted fs-6">
      Summarizer is an AI tool that utilizes advanced AI models such as Google Gemini and other LLMs (Large Language Models) to summarize, explain, paraphrase, or simplify text from taken photos of physical documents or just a photo with text.
    </div>
  </div>
  <hr>

  <!-- Header -->
  <div class="text-center mb-4">
    <h1 class="text-dark">How to use</h1>
    <div class="text-muted fs-6">
      In three steps you got your AI generated results immediately printed on the screen.
    </div>
  </div>

  <!-- How to Use Section -->
  <div class="row g-4">
    <!-- Feature 1: Take a Photo -->
    <div class="col-lg-4 col-12">
      <h3><span class="badge text-bg-primary disabled rounded-3"> 1 </span> <span class="px-2 text-dark mt-3">Choose an Action</span></h3>
      <div class=" text-start h-100 ">
        <div class="">

          <div class="text-muted fs-6">Choose one of the following options based on your need: summarize the content, explain it in more detail, paraphrase it in different words, or simplify it for easier understanding.</div>
        </div>
      </div>
    </div>

    <!-- Feature 2: Summarize -->
    <div class="col-lg-4 col-12">
      <h3><span class="badge text-bg-primary disabled rounded-3"> 2 </span> <span class="px-2 text-dark mt-3">Shoot a photo</span></h3>
      <div class=" text-start h-100 ">
        <div class="">
          <div class="text-muted fs-6">Use your mobile phone, laptop, or tablet to capture an image of a physical document with text, or upload a screenshot instead. Multiple images can be shot or uploaded.</div>
        </div>
      </div>
    </div>

    <!-- Feature 3: Print Output -->
    <div class="col-lg-4 col-12">
      <h3><span class="badge text-bg-primary disabled rounded-3"> 3 </span>  <span class="px-2 text-dark mt-3">Click the ✨ button </span></h3>
      <div class=" text-start h-100 ">
        <div class="">

          <div class="text-muted fs-6">Tap the ✨ button to see what it comes up with!</div>
        </div>
      </div>
    </div>

  </div>
  <hr>

</div>
